import { instance } from "./instance";
import { MediaResponse, MediaListResponse, EpisodesResponse, EpisodeResponse } from "../types/media";

const axios = instance("MEDIA");

export const getMediaList = async (mediaType: string, stationId: string, isEditorChoice?: boolean, genre?: number, search?: string, pageNumber?: number, pageSize?: number,rjId?:string): Promise<MediaListResponse> => {
    const params = new URLSearchParams();
    params.append("mediaType", mediaType);
    params.append("stationId", stationId);
    if (isEditorChoice !== undefined) params.append("isEditorChoice", isEditorChoice.toString());
    if (genre) params.append("genre", genre.toString());
    if (search) params.append("search", search);
    if (pageNumber) params.append("pageNumber", pageNumber.toString());
    if (pageSize) params.append("pageSize", pageSize.toString());
    if (rjId) params.append("rjId",rjId.toString())
    const response = await axios.get<MediaListResponse>(`media?${params.toString()}`);
    return response.data;
};

export const getMedia = async (mediaId: string): Promise<MediaResponse> => {
    const response = await axios.get<MediaResponse>(`media/${mediaId}`);
    return response.data;
};

export const getEpisodes = async (mediaId: string, sortOrder?: 'asc' | 'desc', pageNumber?: number, pageSize?: number): Promise<EpisodesResponse> => {
    const params = new URLSearchParams();
    if (sortOrder) params.append("sortOrder", sortOrder);
    if (pageNumber) params.append("pageNumber", pageNumber.toString());
    if (pageSize) params.append("pageSize", pageSize.toString());
    const response = await axios.get<EpisodesResponse>(`media/${mediaId}/episodes${sortOrder ? `?${params}` : ''}`);
    return response.data;
};

export const getEpisode = async (mediaId: string, episodeId: string): Promise<EpisodeResponse> => {
    const response = await axios.get<EpisodeResponse>(`media/${mediaId}/episodes/${episodeId}`);
    return response.data;
};